module.exports = {"540202001":"城北","540202002":"城南","540202200":"曲美乡","540202201":"聂日雄乡","540202202":"曲布雄乡","540202203":"联乡","540202204":"甲措雄乡","540202205":"纳尔乡","540202206":"年木乡","540202207":"东嘎乡","540202208":"边雄乡","540202209":"江当乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540202.json
// module id = 2491
// module chunks = 0